import { z } from 'zod';

// Messages de validation par défaut en français, pour l'API comme pour les interfaces.
z.config(z.locales.fr());

export * from './commun';
export * from './erreurs';
export * from './auth';
export * from './habilitations';
export * from './administration';
export * from './modules-catalogue';
export * from './parametres';
export * from './workflow';
export * from './documents';
export * from './courriers';
export * from './dossiers';
export * from './recherche';
export * from './indicateurs';
export * from './messagerie-schemas';
export * from './notifications-catalogue';
export * from './supervision-schemas';
export * from './presentation';
export * from './ui-preferences';
export * from './demarches-formulaire';
export * from './demarches-moteur-formulaire';
export * from './demarches-configuration';
export * from './usagers-comptes';
export * from './usagers-dossiers';
export * from './usagers-notifications';
export * from './rendez-vous-agendas';
export * from './reclamations-suivi';
export * from './recettes-socle';
export * from './recettes-catalogue';
export * from './recettes-creances';
export * from './recettes-paiements';
export * from './recettes-caisses';
export * from './marches-structure';
export * from './marches-ciel-ouvert';
export * from './marches-attributions';
export * from './marches-domaine-public';
export * from './interventions';
export * from './terrain';
export * from './proprete';
export * from './inspections';
export * from './depense';
export * from './budget';
export * from './achats';
export * from './travaux';
export * from './patrimoine';
export * from './equipements';
export * from './conseils';
export * from './personnel-conges';
export * from './personnel';
export * from './import-csv';
export * from './personnel-suivi';
export * from './participation';
export * from './evenementiel';
export * from './urbanisme';
export * from './supervision-indicateurs'; // Lot L6-A : supervision nationale complète (M24).
export * from './supervision-competences'; // Lot L6-A : compétences et moyens transférés.
